import { ModalModule } from "ngx-modal";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { DropdownModule } from "ngx-dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { FinancialSettingsRoutingModule } from "./financial-settings-routing.module";
import { PanelMenuModule } from "primeng/panelmenu";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FinancialSettingsComponent } from "./components/financial-settings/financial-settings.component";
import { FinesComponent } from "./components/fines/fines.component";
import { AddFineComponent } from "./components/fines/add-fine/add-fine.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FinancialSettingsRoutingModule,
    PanelMenuModule,
    MultiSelectModule,
    DropdownModule,
    NgSelectModule,
    NgbModule.forRoot(),
    ModalModule,
  ],
  declarations: [FinancialSettingsComponent, FinesComponent, AddFineComponent],
})
export class FinancialSettingsModule {}



// WEBPACK FOOTER //
// ./src/app/financial/financial-settings/financial-settings.module.ts